import React from 'react';
import { InputFieldWithTitles } from '../../../../components/UI-Elements/Select/InputFieldWithTitles';
import { OptionSelect } from '../../../../components/UI-Elements/Select/OptionSelect';
import { Product } from '../../../../sp-types/productType';

interface IProductOverviewDetailsProps {
  accountProducts: Product[];
  currentProduct: Product | undefined;
  setCurrentProduct: React.Dispatch<React.SetStateAction<Product | undefined>>;
}
export const ProductOverviewDetails: React.FC<IProductOverviewDetailsProps> = ({
  currentProduct,
  setCurrentProduct,
  accountProducts,
}) => {
  return (
    <div className="">
      <h6 className="text-red text-lg">Product</h6>
      <div className="flex flex-1 justify-between space-x-8  border-b-2 pb-5 border-gray-100  ">
        <InputFieldWithTitles
          isEditable={false}
          placeHolder="Product ID"
          subtitle="Product ID"
          changeValueFunc={() => {}}
          isNumeric={true}
          value={currentProduct?.id || ''}
        />
        <OptionSelect
          placeHolder="Product"
          disabled={false}
          currentOption={currentProduct?.name || ''}
          options={accountProducts.map((item) => item.name)}
          setCurrentOption={(productN: string) => {
            setCurrentProduct(accountProducts.find((item) => item.name === productN));
          }}
          subtitle="Product"
        />
        <InputFieldWithTitles
          isEditable={false}
          placeHolder="Measurement"
          subtitle="Measurement"
          changeValueFunc={() => {}}
          isNumeric={true}
          value={currentProduct?.measureType || ''}
        />
        <InputFieldWithTitles
          isEditable={false}
          placeHolder="Category"
          subtitle="Category"
          changeValueFunc={() => {}}
          isNumeric={true}
          value={currentProduct?.category || ''}
        />
        <InputFieldWithTitles
          isEditable={false}
          placeHolder="Sub category"
          subtitle="Sub category"
          changeValueFunc={() => {}}
          isNumeric={true}
          value={currentProduct?.subCategory || ''}
        />
      </div>
    </div>
  );
};
